webpackJsonp([80473754865210],{

/***/ 943:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0040_corpse_catapult.jpg","type":"Unit","subtype":"Contraption","cost":3,"ATK":1,"HP":4,"rules_text_1":"Whenever one of your units dies, put a corpse rune on this.","rules_text_2":"⤵, Remove two corpse runes → Deal 6 damage to a building.","rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Corpse Catapult","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"Black","spec":"Necromancy","bottom":"Tech II","rulings":[],"keywords":[],"slug":"corpse_catapult"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"corpse_catapult","keywords":[],"imageRegex":"/corpse_catapult.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-corpse-catapult-38e9fc5c62c4230dee14.js